import { Injectable } from '@angular/core';
import { environment } from '@deltager/organizers/admin/environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    }),
  };

  private readonly STORAGE_KEYS = {
    TOKEN: 'token',
    USER_ID: 'userId',
  };

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) {}

  private static getEndpoints(): any {
    return {
      USER_SWITCH_ORGANIZER: `${environment.oldApiBaseURL}/user/switchOrg/`,
    };
  }

  private gethHttpOptions(): Object {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.getAuthToken(),
      }),
    };
  }

  public isAuthenticated(): boolean {
    // @TODO Check whether the token is expired
    const token = this.getToken();
    return token !== '' && token !== null;
  }

  public getAuthToken(): string {
    if (this.isAuthenticated()) {
      return `Bearer ${this.getToken()}`;
    }
    return '';
  }

  public getAuthHttpHeaders(): HttpHeaders {
    let headers = new HttpHeaders();

    const token = this.getAuthToken();

    if (token?.length > 0) {
      headers = headers.set('Authorization', token);
    }

    return headers;
  }

  private setAuthToken(newToken: string) {
    // eslint-disable-next-line @typescript-eslint/quotes
    const cleanToken = newToken.replace('"', '');
    if (cleanToken.length > 10) {
      this.cookieService.set(this.STORAGE_KEYS.TOKEN, cleanToken, 1, '/');
      localStorage.setItem(this.STORAGE_KEYS.TOKEN, cleanToken);
    }
  }

  private getToken(): string {
    const token = localStorage.getItem(this.STORAGE_KEYS.TOKEN);

    if (token === '' || token === null) {
      return this.cookieService.get(this.STORAGE_KEYS.TOKEN);
    } else {
      return token;
    }
  }

  public logout(): void {
    localStorage.clear();

    this.cookieService.delete(this.STORAGE_KEYS.TOKEN, '/');
    this.cookieService.delete(this.STORAGE_KEYS.USER_ID, '/');
  }

  public authenticate(username: string, password: string, affiliateId: number): Observable<Object> {
    const requestBody = `grant_type=password&username=${encodeURIComponent(username)}&password=${encodeURIComponent(
      password,
    )}&affid=${affiliateId}`;
    return this.http.post(environment.tokenUrl, requestBody, this.httpOptions).pipe(
      map((responseData: any) => {
        this.logout();

        this.setAuthToken(responseData.access_token);
        localStorage.setItem(this.STORAGE_KEYS.USER_ID, responseData.userId);
        return responseData;
      }),
      catchError((error: HttpErrorResponse) => this.handleError(error)),
    );
  }

  public async setClubIdInToken(organizerId: number): Promise<boolean> {
    const newToken = await this.http
      .get<string>(`${AuthService.getEndpoints().USER_SWITCH_ORGANIZER}${organizerId}`, this.gethHttpOptions())
      .toPromise();

    // Set new token value
    if (newToken.length > 10) {
      this.setAuthToken(newToken);
    }

    return true;
  }

  private handleError(error: HttpErrorResponse) {
    if (error instanceof HttpErrorResponse && error.status === 400) {
      return throwError('Incorrect login or password.');
    } else {
      return throwError('Something bad happened; please try again later.');
    }
  }
}
